import React from 'react'
// this is for EF1 - where net new Hoopstir is lookign to sign up as either a club, league or org
export const hoopstirServices = [
  { _id: '1', name: 'Hoopstir Basketball Club', description:
    <div>
      <p>Automate the administrative tasks that come with running your Basketball Club.</p>
      <ul>
        <li>Automate enrolment periods and generate enrolment links</li>
        <li>Offer flexible and sophisticated pricing plans</li>
        <li>3-click-1-page enrolment flow</li>
        <li>Gain detailed insights into your organization's enrolment via the Dashboard</li>
        <li>Set goals, track success and project profits</li>
        <li>Build Teams, assign coaches, export rosters</li>
        <li>Manage your players and send notifications</li>
      </ul> 
    </div>
  },
  { _id: '2', name: 'Hoopstir League', description:
    <div>
      <p>Automate the administrative tasks that come with running your Basketball League</p>
      <ul>
        <li>Create Leagues and set schedules</li>
        <li>Track results and standings</li>
        <li>Decentralize enrolment</li>
        <li>Gain detailed insights into your organizations enrolment via the Hoopstir Dashboard</li>
        <li>Manage your players and send notifications</li>
      </ul> 
    </div>
  },
  { _id: '3', name: 'Hoopstir Basketball Organization', description:
  <div>
    <p>Automate the administrative tasks that come with running your Basketball Club and Leagues and tournaments</p>
    <ul>
      <li>Automate enrolment periods and generate enrolment links</li>
      <li>Offer flexible and sophisticated pricing plans</li>
      <li>3-click-1-page enrolment flow</li>
      <li>Gain detailed insights into your organizations enrolment via the Hoopstir Dashboard</li>
      <li>Set goals track success and project profits</li>
      <li>Build Teams, assign coaches, export rosters</li>
      <li>Manage your players and send notifications</li>
      <li>Create Leagues and set schedules</li>
      <li>Track results and standings</li>
      <li>Decentralize enrolment</li>
    </ul> 
  </div>
  },
]

// Hoopstir Club
// Program types available: Camp, Club Team, Internal League, Skills, Private

// Hoopstir League
// Program types available: External League

// Hoopstir Premium
// Program types available: Camp, Club Team, External League, Internal League, Skills, Private